export default {
  doubleCardSubTile1: 'Let get double card',
  doubleCardSubTile2: 'once finish one more task!',
  getIt: "Get it",
  rewardUpSubTitle: "Sure to give up your reward?",
  rewardUpDoubleTip1: 'Complete',
  rewardUpDoubleTip2: 'Task to get',
  stay: "Stay",
  stillLeave: "Leave",
  rewards: "Rewards",
  task: "Task",
  doubleCard: "Double card",
  extraRewards: "Extra rewards",
  totalReceived: "Total Received",
  extraReward: {
    "step-1-title": "Congratulations on getting priviliage.",
    "step-2-title-1-1": "Just complete",
    "step-2-title-1-2": "tasks",
    "step-2-title-2-1": "and get",
    "step-2-title-2-2": "deposited into your account",
    "step-3-title-1": "Privilege upgrade!",
    "step-3-title-2-1": "Now",
    "step-3-title-2-2": "tasks have been exempted!",
    "step-4-title-1": "Completed 3 tasks already. ",
    "step-4-title-2-1": "Only",
    "step-4-title-2-2": "more tasks can get"
  },
  lastStep: {
    'sub-title-1': "Completed 4 tasks already.",
    'sub-title-2-1': 'Only',
    'sub-title-2-2': 'more',
    'sub-title-2-3': ' tasks can get'
  }
}
